import React from "react";
import './style.scss';
import PropTypes from "prop-types";

const DetailTable = (props) =>{
    
    const { data=[] } = props;
    
    return (
      <table id="UserData">
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td className="header">{row.header}</td>
              <td>{row.values}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
};

DetailTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      values: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
      ]).isRequired,
    })
  ).isRequired,
};
export default DetailTable;


